// tslint:disable
import * as React from 'react';
import { Divider, Row, Upload, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { UploadFile, RcFile } from 'antd/lib/upload/interface';

export interface IValueFilesProps {
  url: string;
  productId: number;
  valueFiles: Array<UploadFile>;
  handleRemove: (f: UploadFile) => void;
  handleChange: (f: any) => void;
  handleOrderChange: (f: any) => void;
}

export default class ValueFiles extends React.Component<IValueFilesProps> {

  constructor(props: IValueFilesProps) {
    super(props);

    this.handleCancel = this.handleCancel.bind(this);
  }

  private prepareUploadFiles() {
    return this.props.valueFiles
      .filter((i: any) => i !== undefined)
      .map((i: any) => {
        return {
          ...i,
          uid: !i.id && i.originFileObj && i.originFileObj.uid ? i.originFileObj.uid : i.id,
          name: i.response ? i.response.file : i.file,
          url: `${this.props.url}/${i.file}`,
          status: 'done',
        };
      })
      .sort((a: any, b: any) => a.priority < b.priority ? -1 : 0);
  }

  public render() {
    const { url, productId, handleChange, handleRemove } = this.props;

    let nextPriority = this.getNewPriority();

    return (
      <Row>
        <div style={{ width: '100%', maxWidth: 500 }}>
          <Upload
            action={`${url}/upload?productId=${productId}&priority=${nextPriority}`}
            defaultFileList={this.prepareUploadFiles()}
            onRemove={handleRemove}
            onChange={handleChange}
            beforeUpload={(file: any, fileList: RcFile[]) => {
              file.priority = nextPriority++;
              return true;
            }}
          >
            <Button>
              <UploadOutlined /> Upload
            </Button>
          </Upload>
        </div>
        <Divider />
      </Row>
    );
  }

  private getNewPriority() {
    const { valueFiles } = this.props;

    let biggestPriority = 0;
    for (const file of (valueFiles as any[]) || []) {
      if (file.priority && file.priority > biggestPriority) {
        biggestPriority = file.priority;
      }
    }

    return biggestPriority + 1;
  }

  private handleCancel() {
    this.setState({
      previewImage: undefined
    });
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/ProductFilesTab/ValueFilesRow.tsx